export const environment = {
    production: true,
    VERSION : "30655"
};